import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { Conditional, WarningToolTip } from '../../../common';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatBadge } from '@blocks-react/components/Badge';
import { ServiceInsightHeadingProps } from '../../types';
import cx from 'classnames';
import styles from './service-insight-heading.module.scss';

export const ServiceInsightHeading = ({
  serviceInsightTranslation,
  isNewCount,
  handleViewAllModal,
  isViewAllBtnEnable = false
}: ServiceInsightHeadingProps) => {
  const isDeskTop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);

  return (
    <div
      className={cx(
        { ['pb-2 pb-lg-0 pt-4 pt-lg-0']: isViewAllBtnEnable },
        'row'
      )}
    >
      <div className="d-flex justify-content-between align-items-center gap-2 pb-lg-3">
        <div className="d-flex align-items-center gap-2">
          <CatHeading variant="title-sm" tabIndex={0}>
            {serviceInsightTranslation.serviceInsightsLabel}
          </CatHeading>
          <WarningToolTip
            isToolTip={false}
            toolTipHeading=""
            toolTipDescription=""
            tooltipHandler={() => null}
          />
          <Conditional test={isNewCount}>
            <CatBadge
              className={styles['new-indicator']}
              text={serviceInsightTranslation.serviceInsightCountLabel}
              data-testid="serviceInsightNewBadge"
            />
          </Conditional>
        </div>
        <Conditional test={isViewAllBtnEnable && !isDeskTop}>
          <CatButton variant="ghost" size="sm" onClick={handleViewAllModal}>
            {serviceInsightTranslation.viewAllText}
          </CatButton>
        </Conditional>
      </div>
    </div>
  );
};
